/**
 * 3D 空间 API（与 universe-space-service 对接）
 */
import request from "@/utils/request";

/**
 * 首页最新活动列表（仅启用，按排序）
 * @param {number} [size=10]
 */
export function getActivityList(params) {
  return request({
    method: "get",
    url: "/api/space/activities",
    params: { size: params?.size ?? 10 },
  });
}

/** 活动详情（含留言、是否已报名） */
export function getActivityDetail(id) {
  return request({
    method: "get",
    url: `/api/space/activities/${id}`,
  });
}

/** 活动报名（需登录） */
export function signupActivity(id) {
  return request({
    method: "post",
    url: `/api/space/activities/${id}/signup`,
  });
}

/** 活动留言（需登录） */
export function postActivityMessage(id, data) {
  return request({
    method: "post",
    url: `/api/space/activities/${id}/messages`,
    data,
  });
}

/**
 * 获取空间列表
 * @param {string} mode - popular | latest | my
 * @param {number} page
 * @param {number} size
 */
export function getSpaceList(params) {
  return request({
    method: "get",
    url: "/api/space/spaces",
    params: {
      mode: params?.mode || "popular",
      page: params?.page ?? 1,
      size: params?.size ?? 12,
    },
  });
}

/**
 * 获取空间详情
 * @param {number} id
 */
export function getSpaceById(id) {
  return request({
    method: "get",
    url: `/api/space/spaces/${id}`,
  });
}

/**
 * 创建空间
 * @param {object} data - { name, description?, thumbnailUrl?, template?, objectsJson?, isPublic? }
 */
export function createSpace(data) {
  return request({
    method: "post",
    url: "/api/space/spaces",
    data,
  });
}

/**
 * 更新空间
 * @param {number} id
 * @param {object} data - { name?, description?, thumbnailUrl?, template?, objectsJson?, isPublic? }
 */
export function updateSpace(id, data) {
  return request({
    method: "put",
    url: `/api/space/spaces/${id}`,
    data,
  });
}

/**
 * 删除空间
 * @param {number} id
 */
export function deleteSpaceById(id) {
  return request({
    method: "delete",
    url: `/api/space/spaces/${id}`,
  });
}

/**
 * 按 slug 获取空间
 * @param {string} slug
 */
export function getSpaceBySlug(slug) {
  return request({
    method: "get",
    url: "/api/space/spaces/by-slug",
    params: { slug },
  });
}

/**
 * Remix 衍生：复制他人空间为我的新空间
 * @param {number} id 原空间 id
 * @param {string} [name] 可选新名称
 */
export function remixSpace(id, name) {
  return request({
    method: "post",
    url: `/api/space/spaces/${id}/remix`,
    data: name ? { name } : {},
  });
}
